import {
  API_TEAM_BY_ID,
  API_TEAM_CREATE,
  API_TEAM_DELETE,
  API_TEAM_EMAIL_TEMPLATE,
  API_TEAM_EMAIL_TEMPLATES,
  API_TEAM_LIST,
  API_TEAM_STATS,
  API_TEAM_UPDATE,
  API_TEAM_USER_TEAMS,
} from 'config'
import Api from 'services/api'

export interface Team {
  id: number
  name: string
  memberIds: number[]
  visible: boolean
  createdAt: string
  updatedAt: string
  createdBy: number
  updatedBy: number
}

export interface CreateTeamData {
  name: string
  memberIds: number[]
  visible?: boolean
}

export interface UpdateTeamData {
  name: string
  memberIds: number[]
  visible?: boolean
}

export const getTeams = (includeInvisible: boolean = false): Promise<Team[]> => {
  return Api.get(API_TEAM_LIST, { includeInvisible })
}

export const getTeamById = (id: number): Promise<Team> => {
  return Api.get(API_TEAM_BY_ID, {}, { id })
}

export const createTeam = (data: CreateTeamData): Promise<Team> => {
  return Api.post(API_TEAM_CREATE, data)
}

export const updateTeam = (id: number, data: UpdateTeamData): Promise<Team> => {
  return Api.put(API_TEAM_UPDATE, data, { id })
}

export const deleteTeam = (id: number): Promise<void> => {
  return Api.delete(API_TEAM_DELETE, {}, { id })
}

export const getTeamStats = (): Promise<any> => {
  return Api.get(API_TEAM_STATS)
}

export const getUserTeams = (userId: number): Promise<Team[]> => {
  return Api.get(API_TEAM_USER_TEAMS, {}, { userId })
}

export interface TeamEmailTemplate {
  id: number
  baseTemplateId: number
  isCustomized: boolean
  overrideId: number | null
  group: string
  purpose?: string[]
  from: string
  to: string[]
  cc: string[]
  subject: string
  title: string
  elements: string[]
  links: any[]
  content: string
  automations?: any[]
}

export const getTeamEmailTemplates = (teamId: number): Promise<TeamEmailTemplate[]> => {
  return Api.get(API_TEAM_EMAIL_TEMPLATES, {}, { id: teamId })
}

export const upsertTeamEmailTemplate = (
  teamId: number,
  baseTemplateId: number,
  data: Record<string, any>,
): Promise<TeamEmailTemplate> => {
  return Api.put(API_TEAM_EMAIL_TEMPLATE, data, { id: teamId, baseTemplateId })
}

export const resetTeamEmailTemplate = (teamId: number, baseTemplateId: number): Promise<TeamEmailTemplate> => {
  return Api.delete(API_TEAM_EMAIL_TEMPLATE, {}, { id: teamId, baseTemplateId })
}
